import React from 'react'
import Typography from '@material-ui/core/Typography';
import useStyles from './style';


const OverviewCardViewer = (props) => {
    const { src, isUpdated, data } = props
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <img src={src} alt="obligation" className={classes.image} />
            <div className={classes.content}>
                    <Typography className={classes.title}>{isUpdated ?  data?.title : data?.createTitle}</Typography>
                <Typography className={classes.description}>{isUpdated ? data?.description : data?.createDescription}</Typography>
            </div>
        </div>
    )
}

export default OverviewCardViewer